if (!customElements.get('theme-drag-scroll')) {
  class ThemeDragScroll extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector(':scope > .theme-drag-scroll__list');
      if (!this.list) return;

      this.alignMobile = this.dataset.alignMobile || 'start';
      this.alignDesktop = this.dataset.alignDesktop || 'start';
      this.pointerDown = false;
      this.preventClick = false;

      this._boundMouseDown = this._onMouseDown.bind(this);
      this._boundMouseMove = this._onMouseMove.bind(this);
      this._boundMouseUp = this._onMouseUp.bind(this);
      this._boundClickCapture = this._onClickCapture.bind(this);

      this.controller = new AbortController();
      const sig = this.controller.signal;

      this.list.addEventListener('mousedown', this._boundMouseDown, { signal: sig });

      this.resizeObserver = new ResizeObserver(() => this.remeasure());
      this.resizeObserver.observe(this);
      sig.addEventListener('abort', () => this.resizeObserver.disconnect());

      this.remeasure();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.dragController?.abort();
      this.dragController = null;
    }

    remeasure() {
      if (!this.list) return;

      const overflowing = this.list.scrollWidth > this.list.clientWidth + 1;
      this.toggleAttribute('overflowing', overflowing);

      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const align = overflowing ? 'start' : (isDesktop ? this.alignDesktop : this.alignMobile);
      const justify = align === 'center' ? 'center' : align === 'end' ? 'flex-end' : 'flex-start';
      this.list.style.justifyContent = justify;
    }

    reanchor() {
      this.remeasure();
    }

    _onMouseDown(e) {
      if (e.button !== 0) return;
      if (!this.hasAttribute('overflowing')) return;

      this.pointerDown = true;
      this.preventClick = false;
      this.dragStartX = e.clientX;
      this.scrollStartX = this.list.scrollLeft;
      this.classList.add('grabbing');
      e.preventDefault();

      this.dragController = new AbortController();
      const sig = this.dragController.signal;
      document.addEventListener('mousemove', this._boundMouseMove, { signal: sig });
      document.addEventListener('mouseup', this._boundMouseUp, { signal: sig });
      document.addEventListener('mouseleave', this._boundMouseUp, { signal: sig });
      document.addEventListener('click', this._boundClickCapture, { signal: sig, capture: true });
    }

    _onMouseMove(e) {
      if (!this.pointerDown) return;

      const dx = e.clientX - this.dragStartX;
      this.list.scrollLeft = this.scrollStartX - dx;
      if (Math.abs(dx) > 10) this.preventClick = true;
    }

    _onMouseUp() {
      if (!this.pointerDown) return;

      this.pointerDown = false;
      this.classList.remove('grabbing');
      this.dragController?.abort();
      this.dragController = null;
    }

    _onClickCapture(e) {
      if (this.preventClick) {
        e.stopPropagation();
        e.preventDefault();
        this.preventClick = false;
      }
    }
  }

  customElements.define('theme-drag-scroll', ThemeDragScroll);
}
